export class CompanySummerRetentionDataModel implements ICompanySummerRetentionDataModel {
  totalWithIntentToReturn?: number | undefined;
  returnedNextSeason?: number | undefined;
  retentionPercentage?: number | undefined;

  constructor(data?: ICompanySummerRetentionDataModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.totalWithIntentToReturn = Data["totalWithIntentToReturn"];
      this.returnedNextSeason = Data["returnedNextSeason"];
      this.retentionPercentage = Data["retentionPercentage"];
    }
  }

  static fromJS(data: any): CompanySummerRetentionDataModel {
    data = typeof data === 'object' ? data : {};
    let result = new CompanySummerRetentionDataModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalWithIntentToReturn"] = this.totalWithIntentToReturn;
    data["returnedNextSeason"] = this.returnedNextSeason;
    data["retentionPercentage"] = this.retentionPercentage;
    return data;
  }
}

export interface ICompanySummerRetentionDataModel {
  totalWithIntentToReturn?: number | undefined;
  returnedNextSeason?: number | undefined;
  retentionPercentage?: number | undefined;
}